import React, { useReducer } from 'react';
import DecodeGlobalContext, { initialState } from '../../redux/decodeGlobalContext';
import DecodeGlobalReducer from '../../redux/decodeGlobalReducer';

const DecodeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(DecodeGlobalReducer, initialState);

  return (
    <DecodeGlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </DecodeGlobalContext.Provider>
  );
};

// const WithApolloWrapped = withApollo(DecodeProvider);

export default DecodeProvider;
